import { h } from '@stencil/core';
import { SVGOpts } from '../icons-opts';

export const Close = (opts?: SVGOpts) => (
  <svg
    viewBox="0 0 24 24"
    width={opts?.width}
    height={opts?.height}
    class={opts?.class}
    xmlns="http://www.w3.org/2000/svg">
    <path d="M14.546 12.0004L22.2382 4.30813L23.8245 2.72183C24.0585 2.48783 24.0585 2.10756 23.8245 1.87356L22.1272 0.176258C21.8932 -0.0577525 21.5129 -0.0577525 21.2789 0.176258L12.0004 9.4548L2.72184 0.175508C2.48783 -0.0585025 2.10757 -0.0585025 1.87356 0.175508L0.175508 1.87281C-0.0585025 2.10682 -0.0585025 2.48708 0.175508 2.72108L9.4548 12.0004L0.175508 21.2789C-0.0585025 21.5129 -0.0585025 21.8932 0.175508 22.1272L1.87281 23.8245C2.10682 24.0585 2.48708 24.0585 2.72109 23.8245L12.0004 14.5459L19.6926 22.2382L21.2789 23.8245C21.5129 24.0585 21.8932 24.0585 22.1272 23.8245L23.8245 22.1272C24.0585 21.8932 24.0585 21.5129 23.8245 21.2789L14.546 12.0004Z" />
  </svg>
);
